import { reactive, toRefs, watch, computed, onMounted } from 'vue';
// import { getToken } from '@/utils/auth';
import { ElMessage } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import Cookies from 'js-cookie';
// import {setChunkUpload} from '@/utils/setHeader'
export default {
  name: 'EIUploadOnePic',
  components: {
    Plus
  },
  props: {
    action: {
      default: '',
      type: String
    },
    fileList: {
      default: function () {
        return [];
      },
      type: Array
    },
    type: {
      default: 'image',
      type: String
    },
    fileType: {
      default: '',
      type: String
    },
    uploadTip: {
      default: '',
      type: String
    }
  },
  emits: ['update:fileList', 'clearValidate'],
  setup(props, context) {
    watch(props.fileList, val => {
      state.url = '';
    }, {
      lazy: true
    });
    const state = reactive({
      url: '',
      baseUrl: `${window.g.imgUrlPrex}`,
      fileListAll: [],
      headers: {
        'Authorization': Cookies.get('accessToken')
      }
    });
    const fileName = computed(() => {
      return props.fileList[0]?.fileName;
    });
    // 调用初始化方法
    onMounted(() => {
      if (props.fileList || props.fileList.length > 0) {
        methods.initFileList();
      }
    });
    const methods = reactive({
      // 将URL列表转换为fileList格式
      initFileList() {
        state.fileListAll = []; // 清空之前的列表
        props.fileList.forEach(url => {
          // 如果是本地路径（以 / 开头）或完整 URL（包含 http:// 或 https://），则不加 baseUrl
          if (url && (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:'))) {
            state.fileListAll.push(url);
          } else {
            state.fileListAll.push(state.baseUrl + url);
          }
        });
      },
      // 上传文件格式一律转为小写
      commonHandleCheck(val) {
        let testmsg = val.substring(val.lastIndexOf('.') + 1);
        testmsg && (testmsg = testmsg.toLowerCase());
        return testmsg;
      },
      // 设置请求头
      requestHeaderSet() {
        state.headers['Authorization'] = 'Bearer ' + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
        const temp = setChunkUpload();
        state.headers['signature'] = temp.signature;
        state.headers['timestamp'] = temp.timestamp;
        state.headers['nonce'] = temp.nonce;
      },
      handleFileSuccess(res, file) {
        let fileList = [{
          chunkNumber: null,
          chunkSize: null,
          currentChunkSize: null,
          fileGroup: res.group,
          fileSize: file.size,
          fileType: null,
          fileName: file.name,
          group: res.group,
          identifier: null,
          merge: false,
          path: res.path,
          relativePath: null,
          skipAll: false,
          skipUpload: false,
          totalChunks: null,
          totalSize: null,
          uploaded: null
        }];
        context.emit('update:fileList', fileList);
        context.emit('clearValidate');
      },
      handleAvatarSuccess(res, file) {
        console.log('handleAvatarSuccess', res);
        state.url = URL.createObjectURL(file.raw);
        res.fileGroup = res.group;
        res.fileName = res.filename;
        delete res.filename;
        res = [res];
        console.log(res, 'res***************');
        context.emit('update:fileList', res[0].data.url);
        context.emit('clearValidate');
      },
      beforeAvatarUpload(file) {
        let testmsg = methods.commonHandleCheck(file.name);
        const isJPEG = testmsg === 'jpeg';
        const isJPG = testmsg === 'jpg';
        const isPNG = testmsg === 'png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG && !isPNG && !isJPEG) {
          ElMessage.error('上传图片只能是 JPG、JPEG、PNG、GIF格式!');
          return false;
        }
        if (!isLt2M && file.size == 0) {
          ElMessage.error('上传图片大小不能超过 2MB!');
          return false;
        }
        return isJPG || isPNG || isJPEG;
      }
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      fileName
    };
  }
};